import { SSC_SEM_API_URL } from "../../settings/config";
import { getRegionalDatabasesInProgress, getRegionalDatabasesSuccess, getRegionalDatabasesFailed } from "./creators";
import { authRequest } from "../authorizedRequests";

export const fetchRegionalDatabases = _ => {
  return (dispatch, getState) => {
    const apiUrl = `${SSC_SEM_API_URL}/regional-databases`;
    const regionalDatabases = getState().regional_databases.data;

    if (regionalDatabases) {
      return Promise.resolve();
    }

    dispatch(getRegionalDatabasesInProgress());

    authRequest(apiUrl, dispatch, getState)
      .then(response => {
        dispatch(getRegionalDatabasesSuccess(response));
      })
      .catch(_ => {
        dispatch(getRegionalDatabasesFailed());
      });
  };
};
